import { Building2, Globe, LockKeyhole } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { Apollo } from 'src/gql/generated';

export const SKILL_ICON_COLOR = '#7C5CFC';

/** The icon for each sharing scope wherever a skill is listed, next to its label. */
export const SKILL_SCOPE_ICONS = {
  [Apollo.AgentSkillScope.Community]: Globe,
  [Apollo.AgentSkillScope.Org]: Building2,
  [Apollo.AgentSkillScope.Personal]: LockKeyhole,
} satisfies Record<Apollo.AgentSkillScope, LucideIcon>;

/** Who can see a skill, shown when hovering its scope icon. */
export const SKILL_SCOPE_DESCRIPTIONS = {
  [Apollo.AgentSkillScope.Community]: 'Shared with the Aline Community',
  [Apollo.AgentSkillScope.Org]: 'Shared with your organization',
  [Apollo.AgentSkillScope.Personal]: 'Private to you',
} satisfies Record<Apollo.AgentSkillScope, string>;
